export class RequestUser {
  constructor (
    public email: string,
    public password: string,
    public deviceDetails: null, // put here for completion sake, but the web api takes null for desktop device
    public intent: LoginIntent
  ) {}
}

export enum LoginIntent {
  Login = 0,
  ForgotPassword = 1
}
